export const LIST_PARTNER_REQ = "LIST_PARTNER_REQ";
export const LIST_PARTNER_SUCCESS = "LIST_PARTNER_SUCCESS";
export const LIST_PARTNER_FAILED = "LIST_PARTNER_FAILED";
